import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { EpicRefined } from 'interfaces/middleware'
import { of, merge } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { CCLockCardAction, CCOnboardingActions, CCUnlockCardAction } from 'components/features/creditCard/creditCardStore/actions'
import { CC_ACTIVATE_URL, CC_LOCK_URL } from 'components/features/creditCard/creditCardStore/endpoints'
import FloatingPaneAction, { ModifyFloatingPaneAction } from 'actions/floatingPanesActions'
import { CREDIT_CARD_PANE } from 'components/features/creditCard/creditCardStore/floatingPane'

export const ccLockEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions | FloatingPaneAction> = (action$, _, { post }) => action$.pipe(
  filterRequest(CCLockCardAction.type),
  mergeMap((action) => {
    return post({ url: CC_LOCK_URL, params: { uid: action.payload.params.uid }}, { body: {}}).pipe(
      mergeMap(({ response }) => {
        return merge(
          of(action.success(response)),
          of(new ModifyFloatingPaneAction({
            type: CREDIT_CARD_PANE,
            mode: 'lockOrUnlock',
          })),
        )
      }),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status, errorsMap: error.response })))
    )
  }),
)

export const ccUnlockEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions | FloatingPaneAction> = (action$, _, { post }) => action$.pipe(
  filterRequest(CCUnlockCardAction.type),
  mergeMap((action) => {
    return post({ url: CC_ACTIVATE_URL, params: { uid: action.payload.params.uid }}, { body: {}}).pipe(
      mergeMap(({ response }) => {
        return merge(
          of(new ModifyFloatingPaneAction({
            type: CREDIT_CARD_PANE,
            mode: 'lockOrUnlock',
          })),
          of(action.success(response)),
        )
      }),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status, errorsMap: error.response })))
    )
  }),
)
